<template>
  <section>
    <Title :title-name="title.Message.titleName" :title-link="title.Message.titleLink" />
    <div class="container">
      <div style="margin: 14pt 0">
        <p>Dear {{ pax.title }} {{ pax.first_name }} {{ pax.last_name }},</p>
        We are still waiting for passenger you are traveling with to respond to your request.
      </div>
    </div>
  </section>
</template>

<script>
import Title from '@/components/Title/index'

export default {
  name: 'Message',
  components: { Title },
  props: {
    secret: {
      type: String,
      default: ''
    }
  }
}
</script>
